import { useState } from "react";
import T from "./theme";
import { NAV } from "./data";

import Nav               from "./components/Nav";
import HomeSection       from "./sections/HomeSection";
import AboutSection      from "./sections/AboutSection";
import TimelineSection   from "./sections/TimelineSection";
import PetitionSection   from "./sections/PetitionSection";
import SocialSection     from "./sections/SocialSection";
import HallOfFameSection from "./sections/HallOfFameSection";
import GallerySection    from "./sections/GallerySection";

export default function App() {
  const [active, setActive] = useState("Home");

  function setSection(name) {
    setActive(name);
    const id = name.toLowerCase().replace(/ /g, "-");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div style={{ background: T.bg0, minHeight: "100vh", fontFamily: T.sans }}>
      <Nav active={active} setActive={setActive} setSection={setSection} />

      <div style={{ paddingTop: 64 }}>
        <div id="home"><HomeSection /></div>
        <div id="about"><AboutSection /></div>
        <div id="timeline"><TimelineSection /></div>
        <div id="petition"><PetitionSection /></div>
        <div id="social"><SocialSection /></div>
        <div id="hall-of-fame"><HallOfFameSection /></div>
        <div id="gallery"><GallerySection /></div>
      </div>

      <footer style={{ background: T.bg0, borderTop: `1px solid ${T.borderDim}` }}>
        <div className="footer-inner">
          <div>
            <div style={{ fontFamily: T.mono, fontWeight: 700, fontSize: 14, color: T.white, letterSpacing: 3 }}>SCI-COM 2026</div>
            <div style={{ color: T.gray2, fontSize: 12, fontFamily: T.mono, marginTop: 4 }}>Potisarnpittayakorn School · Bangkok</div>
          </div>
          <div className="footer-nav">
            {NAV.map((n) => (
              <button key={n} onClick={() => setSection(n)} style={{
                background: "none", border: "none", color: T.gray2, fontSize: 11,
                fontFamily: T.mono, cursor: "pointer", letterSpacing: 1,
                textTransform: "uppercase", padding: 0,
              }}>{n}</button>
            ))}
          </div>
          <div style={{ color: T.gray3, fontSize: 11, fontFamily: T.mono }}>© 2026 SCI-COM. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
}
